import { Phone, Laptop, Chip, PlayVideo } from "./Mockups";

const Full = ({ src, alt }) => (
  <img src={src} alt={alt} loading="lazy" className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-[1.06]" />
);

export const ProjectStage = ({ p, play = false }) => {
  switch (p.stage) {
    case "egg":
      return (
        <>
          <img src="/work/egg_cut.png" alt="Egg donor TikTok" className="float-y absolute left-1/2 top-[7%] h-[86%] -translate-x-1/2 drop-shadow-[0_40px_60px_rgba(0,0,0,0.7)] transition-transform duration-700 group-hover:scale-105" />
          <Chip className="absolute left-[8%] top-[18%]">TikTok</Chip>
          <Chip className="absolute bottom-[16%] right-[8%] !bg-[var(--acid)] !text-[var(--ink)]">8M+ views</Chip>
        </>
      );
    case "identity":
      return (
        <div className="absolute inset-3 grid grid-cols-3 grid-rows-2 gap-3 sm:inset-4">
          {[["/work/mock_stationery.jpg", "col-span-2 row-span-2"], ["/work/gd/mock_kekse.jpg", ""], ["/work/gd/mock_adela.jpg", ""]].map(([s, cls]) => (
            <div key={s} className={`relative overflow-hidden rounded-xl ${cls}`}>
              <img src={s} alt="Brand identity mockup" loading="lazy" className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-110" />
            </div>
          ))}
        </div>
      );
    case "banners":
      return (
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="w-[84%] overflow-hidden rounded-xl bg-white shadow-[0_40px_80px_-20px_rgba(0,0,0,0.8)] transition-transform duration-700 group-hover:-translate-y-2">
            <div className="flex gap-1.5 bg-zinc-200 px-3 py-2"><span className="h-2.5 w-2.5 rounded-full bg-[#ff5f57]" /><span className="h-2.5 w-2.5 rounded-full bg-[#febc2e]" /><span className="h-2.5 w-2.5 rounded-full bg-[#28c840]" /></div>
            <div className="relative h-[58vw] max-h-[340px] overflow-hidden sm:h-[300px]">
              <div className="scroll-y flex flex-col gap-2 p-2">
                {[42, 44, 46, 48, 49, 50, 51, 52, 53, 54, 42, 44, 46, 48, 49, 50, 51, 52, 53, 54].map((n, k) => (
                  <img key={k} src={`/work/gd/w${n}.jpg`} alt="Email banner" className="w-full rounded" />
                ))}
              </div>
            </div>
          </div>
        </div>
      );
    case "stand":
      return (
        <>
          <Full src="/work/gd/s2.jpg" alt="3D interior render" />
          <Chip className="absolute left-[6%] top-[8%]">Render · 3D</Chip>
          <div className="absolute bottom-[7%] right-[6%] w-[30%] overflow-hidden rounded-xl shadow-2xl ring-1 ring-white/20 transition-transform duration-700 group-hover:-translate-y-3 group-hover:rotate-[3deg]">
            <img src="/work/gd/s3.png" alt="Trade fair stand" className="aspect-[4/3] w-full object-cover" />
          </div>
        </>
      );
    case "phones":
      return (
        <div className="absolute inset-0 flex items-center justify-center gap-[3%]">
          {["f2", "f1", "f3"].map((f, i) => (
            <div key={f} className={`w-[24%] transition-transform duration-700 ${i === 0 ? "rotate-[-8deg] translate-y-4 group-hover:rotate-[-12deg]" : i === 2 ? "rotate-[8deg] translate-y-4 group-hover:rotate-[12deg]" : "-translate-y-2 group-hover:-translate-y-6"}`}>
              <Phone src={`/work/${f}.png`} alt="VMware ad" />
            </div>
          ))}
        </div>
      );
    case "savvy":
      return (
        <>
          <Full src="/work/savvy/i2.jpg" alt="Savvy Llama starter kit" />
          <div className="absolute bottom-[6%] right-[5%] w-[24%] overflow-hidden rounded-xl shadow-[0_30px_60px_-15px_rgba(0,0,0,0.8)] ring-1 ring-white/20 transition-transform duration-700 group-hover:-translate-y-3">
            <PlayVideo src="/video/savvy_kit.mp4" poster="/video/savvy_kit.jpg" play={play} className="aspect-[9/16] w-full object-cover" />
          </div>
          <Chip className="absolute left-[5%] top-[7%]">New York</Chip>
        </>
      );
    case "guidelines":
      return (
        <div className="absolute inset-0 flex items-center justify-center bg-[#efe6e4]">
          <img src="/work/savvy/stand_5.jpg" alt="Savvy Llama guidelines" className="absolute w-[70%] translate-x-[-12%] translate-y-[-8%] rotate-[-5deg] rounded-md shadow-xl transition-transform duration-700 group-hover:rotate-[-8deg]" />
          <img src="/work/savvy/stand_4.jpg" alt="Savvy Llama stand" className="absolute w-[70%] translate-x-[12%] translate-y-[8%] rotate-[3deg] rounded-md shadow-2xl transition-transform duration-700 group-hover:rotate-[5deg] group-hover:scale-105" />
        </div>
      );
    case "posters":
      return (
        <div className="absolute inset-0 flex items-center justify-center">
          {[["/work/gd/w29.jpg", "-translate-x-[70%] rotate-[-9deg] group-hover:-translate-x-[85%] group-hover:rotate-[-13deg]"], ["/work/gd/w28.jpg", "translate-x-[70%] rotate-[9deg] group-hover:translate-x-[85%] group-hover:rotate-[13deg]"], ["/work/f1.png", "-translate-y-2 group-hover:-translate-y-5 group-hover:scale-105"]].map(([s, cls]) => (
            <div key={s} className={`absolute w-[30%] bg-white p-1.5 shadow-[0_30px_60px_-15px_rgba(0,0,0,0.85)] transition-transform duration-700 ${cls}`}>
              <img src={s} alt="Poster" loading="lazy" className="aspect-[3/4] w-full object-cover object-top" />
            </div>
          ))}
        </div>
      );
    case "cafe":
      return (
        <div className="absolute inset-0 flex items-center justify-center">
          {[["cafe_2", "-translate-x-[62%] rotate-[-10deg] group-hover:-translate-x-[78%] group-hover:rotate-[-14deg]"], ["cafe_3", "translate-x-[62%] rotate-[10deg] group-hover:translate-x-[78%] group-hover:rotate-[14deg]"]].map(([c, cls]) => (
            <div key={c} className={`absolute w-[34%] overflow-hidden rounded-xl shadow-[0_30px_60px_-15px_rgba(0,0,0,0.8)] ring-1 ring-white/15 transition-transform duration-700 ${cls}`}>
              <img src={`/work/cafe/${c}.jpg`} alt="Better Brew branding" loading="lazy" className="aspect-[4/5] w-full object-cover" />
            </div>
          ))}
          <div className="absolute w-[36%] -translate-y-1 overflow-hidden rounded-xl shadow-[0_30px_60px_-15px_rgba(0,0,0,0.8)] ring-1 ring-white/15 transition-transform duration-700 group-hover:-translate-y-4 group-hover:scale-105">
            <PlayVideo src="/video/brew.mp4" poster="/video/brew.jpg" play={play} className="aspect-[3/4] w-full object-cover" />
            <Chip className="absolute bottom-3 left-3">Instagram</Chip>
          </div>
        </div>
      );
    case "laptop":
      return (
        <>
          <Laptop src="/work/p3.png" alt="Feed redesign" className="absolute left-[8%] top-[16%] w-[70%] transition-transform duration-700 group-hover:-translate-y-2" />
          <div className="absolute bottom-[6%] right-[8%] w-[22%] transition-transform duration-700 group-hover:-translate-y-4 group-hover:rotate-[4deg]">
            <Phone src="/video/beauty.jpg" video="/video/beauty.mp4" play={play} alt="Beauty reel" />
          </div>
        </>
      );
    case "mens":
      return (
        <>
          <img src="/work/men_cut.png" alt="Men's fertility campaign" className="absolute left-[4%] top-1/2 w-[72%] -translate-y-1/2 drop-shadow-[0_40px_60px_rgba(0,0,0,0.7)] transition-transform duration-700 group-hover:scale-105" />
          <div className="absolute bottom-[7%] right-[7%] w-[23%] transition-transform duration-700 group-hover:-translate-y-4 group-hover:rotate-[-4deg]">
            <Phone src="/video/adela.jpg" video="/video/adela.mp4" play={play} alt="Dra. Adela Camus reel" />
          </div>
          <Chip className="absolute left-[8%] top-[12%]">Education</Chip>
        </>
      );
    default:
      return <Full src="/work/mock_brochure.jpg" alt="Austin Ingenieros brochure mockup" />;
  }
};
